import React, { Component } from 'react';
import { Row, Col, Grid, Container } from 'react-bootstrap';
//import logo from './logo.svg';
import './App.css';
import Leaf from './components/Leaf';
import Modal from './components/Modal'
import 'bootstrap/dist/css/bootstrap.min.css';
import classes from './app.module.css';
import logo from './assets/icons8-radio-tower-64_2.png';

class App extends Component {

  render() {
    return (
      <div className="App">
          <div className={classes.titleText}>
            <h1 className={classes.title}><b>Link</b></h1>
          <h1 className={classes.titleTextTwo}><b>NYC</b></h1>

          
        </div>
          <Leaf/>
      </div>
    );
  }
}

export default App;

/**
 * <img src={logo} alt="logo" className={classes.titleImage} />
 */